import React from 'react';
import '../styles/Teachers.css'; // or your global CSS file
import { UserPlus, Users, GraduationCap } from 'lucide-react';


const Teachers = () => {
  return (
    <div className="teachers-page">
      <header className="teacher-header">
        <h1 style={{ color: 'var(--header-text)' }}>
          <GraduationCap size={28} style={{ marginRight: '10px', verticalAlign: 'middle' }} />
          Teachers
        </h1>
        <p style={{ color:  'var(--subheader-text)' }}>
          Overview of all current and substitute teachers.
        </p>
      </header>

      <section className="card-grid "role="region" aria-label="Teacher Stats">
        <div className="card">
          <div className="card-icon">
            <UserPlus size={22} />
          </div>
          <h3>New Hires</h3>
          <p>2 pending onboarding</p>
          <span className="badge warning">Action Required</span>
        </div>

        <div className="card">
          <div className="card-icon">
            <Users size={22} />
          </div>
          <h3>Active Teachers</h3>
          <p>8 Total</p>
          <span className="badge success">Active</span>
        </div>

        <div className="card">
          <div className="card-icon">
           <GraduationCap size={28} style={{ marginRight: '10px', verticalAlign: 'middle' }} /> 
          </div>
          <h3>Substitutes Available</h3>
          <p>2 Ready</p>
          <span className="badge info">Available</span>
        </div>
      </section>
    </div>
  );
};

export default Teachers;
